module.exports = __webpack_public_path__ + "static/about-img-a23c2e2f17cd8c4795bf36e122e01a20.jpg";